import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import moment = require('moment');
import { EventId } from '../../../models/eventId.model';
import { Remittance } from '../../../models/remittance.model';
import { AuthorizationService } from '../../../services/authorization.service';
import { EventIdHelper } from '../helpers/event-search.eventIdHelper';

@Component({
  selector: 'app-eventsearch-postedremittance-seidupdate',
  templateUrl: './eventsearch-postedremittance-seidupdate.component.html',
  styleUrls: ['./eventsearch-postedremittance-seidupdate.component.css'],
})
export class EventSearchPostedRemittanceSEIDUpdateComponent implements OnChanges {
  @Input() selectedRemittance: Remittance;
  @Input() seid: string;
  @Input() postedRemittanceSEIDUpdateModal: boolean;

  @Output() postedRemittanceSEIDUpdateModalChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onModalAction: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('ncpdp') ncpdp: ElementRef;

  public seidUpdateForm: FormGroup;
  public seidsAreDifferent: boolean

  public yearRange = `1970:${new Date().getFullYear()}`
  public firstSearch: boolean
  public eventLoaded = true;

  public searchValidationError: boolean;
  public searchValidationErrorMessage: string;
  public formValidationMessages = {
    required: 'This Field is Required!',
  };

  private _eventIdModel: EventId = new EventId();
  get eventIdModel(): EventId {
    return this._eventIdModel
  }
  set eventIdModel(value: EventId) {
    this._eventIdModel = value;
  }

  constructor(private authorizationService: AuthorizationService,
              private fb: FormBuilder) {
    this.initForm();
  }

  initForm(): void {
    this.seidUpdateForm = this.fb.group({
      ncpdp: new FormControl({ disabled: true }, [
        Validators.required,
        Validators.minLength(7),
        Validators.maxLength(7),
        Validators.pattern('[0-9]{7}'),
      ]),
      prescriptionNumber: new FormControl({ disabled: true }, [
        Validators.required,
        Validators.maxLength(12),
      ]),
      fillDate: new FormControl(null, [
        Validators.required,
      ]),
    })
    //  Set submit button state based on comparison between original and new SEIDs.
    this.seidUpdateForm.valueChanges.subscribe(() => this.onFormValueChange())

    //  Track form updates (cut-and-paste) in ncpdp field.
    this.seidUpdateForm.controls['ncpdp'].valueChanges.subscribe((selectedValue: string) => this.onCriteriaChange(selectedValue))
  };

  onFormValueChange(): void {
    //  If the new SEID value has changed, set the flag that drives the submit button state.
    this.seidsAreDifferent = this.AreSEIDsDifferent()
  }

  AreSEIDsDifferent(): boolean {
    let result = false;
    if (this.seid) {
      let ncpdp = this.seidUpdateForm.controls['ncpdp'].value
      let rx = this.seidUpdateForm.controls['prescriptionNumber'].value
      let fillDate = this.seidUpdateForm.controls['fillDate'].value
      let newSeid =
        // tslint:disable-next-line:max-line-length
        `${ncpdp}-${rx}-${moment(fillDate).format('YYYYMMDD')}`;
      result = this.seid !== newSeid
    }
    return result;
  }

  setInputFocus() {
    this.ncpdp.nativeElement.focus();
  }

  ngOnChanges(): void {
    if (this.seid) {
      this.onCriteriaChange(this.seid);
    }
  }

  onCriteriaChange(value?: string): void {
    //  Try to parse the value into an SEID
    let eventId = new EventIdHelper().toEventId(value);

    //  If we got a valid SEID, then update the form with the
    //  parsed (split) value.
    if (eventId && eventId.eventValid) {
      this.eventIdModel = eventId
      let filldate = moment(this.eventIdModel.fillDate)
      this.seidUpdateForm.setValue({
        ncpdp: this.eventIdModel.ncpdp,
        prescriptionNumber: this.eventIdModel.prescriptionNumber,
        fillDate: filldate.toDate(),
      })
    }
  }

  reset(): void {
    this.callNotifyService();
    this.seidUpdateForm.reset();
  }

  // called by get functions to update the timer every time an api is called
  private callNotifyService() {
    if (!this.authorizationService.HealthcareTopBar || !this.authorizationService.HealthcareTopBar.notifyActivity) {
      return;
    }
    this.authorizationService.HealthcareTopBar.notifyActivity();
  }

  cancelClick() {
    this.seidUpdateForm.reset();
    this.postedRemittanceSEIDUpdateModal = false;
    this.postedRemittanceSEIDUpdateModalChange.emit(this.postedRemittanceSEIDUpdateModal);
    this.onModalAction.emit({ type: 'cancel' })
  }

  submitClick() {
    let rxNumber = Number(this.seidUpdateForm.controls['prescriptionNumber'].value)
    let fillDate = moment(this.seidUpdateForm.controls['fillDate'].value)

    this.eventIdModel = new EventId(this.seidUpdateForm.controls['ncpdp'].value.trim(), rxNumber, fillDate.toDate())
    this.onModalAction.emit({ type: 'submit', value: this.eventIdModel })
  }
}



// WEBPACK FOOTER //
// ./src/app/components/event-search/eventsearch-postedremittance-seidupdate/eventsearch-postedremittance-seidupdate.component.ts